import { API } from "../../apiSlice";

export const getRecaptchaApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getRecaptcha: builder.query({
      query: () => {
        return {
          url: `users/captcha`,
        };
      },
    }),
  }),
});

export const { useGetRecaptchaQuery } = getRecaptchaApiSlice;
